export default {
  table: {
    marjorShareHolders: 1,
    boardOfDirectors: 2,
  },

  Export: 'EXPORT',
  IS_RELATIONSHIP: 'isRelationship',

  listTitleChart: {
    Overview: 'OVERVIEW',
    MajorOwnerships: 'MAJOR OWNERSHIPS',
  },

  listTab: {
    MajorShareHolders: {
      Name: 'MAJOR SHAREHOLDERS',
      Index: 1,
    },
    BoardOfDirectors: {
      Name: 'BOARD OF DIRECTORS',
      Index: 2,
    },
  },

  listTitleTableMajorShareHolders: {
    NAME: 'shareHolderName',
    SHARES: 'quantity',
    PERCENTAGE: 'percentage',
    PUBLIC_DATE: 'publicDate',
    //SHAREHOLDER_CODE: 'shareHolderCode',
  },

  listTitleTableBOD: {
    NAME: 'fullName',
    POSITION: 'positionName',
    SHARES: 'quantity',
    PERCENTAGE: 'percentage',
    PUBLIC_DATE: 'publicDate',
  },

  listTicker: {
    ORGAN_CODE: 'organCode',
    TICKER: 'ticker',
    ORGAN_SHORT_NAME: 'organShortName',
    COM_GROUP_CODE: 'comGroupCode',
  },

  listIndex: {
    COM_GROUP_CODE: 'comGroupCode',
    COM_GROUP_NAME: 'comGroupName',
    PARENT_COM_GROUP_CODE: 'parentComGroupCode',
  },

  listIndexName: {
    vnIndex: 'VNINDEX',
    hnIndex: 'HNXINDEX',
    upcomIndex: 'UPCOMINDEX',
  },

  listIndexExchange: {
    hose: 'HOSE',
    hnx: 'HNX',
    upcom: 'UPCOM',
  },
};
